"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _reactMintl = require("@godaddy/react-mintl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const PLIDS_FOR_123_REG = [525844, 587240];

/**
 * Configuration for the GoLF i18n string (and associated EID)
 * of the privacy policy links in this footer component. These
 * are included here (again) so that component can stand alone
 * when reused across multiple header services.
 */
const privacyLinks = {
  policy: {
    golf: 'PC:AppHeader:Footer:PrivacyPolicy',
    eid: 'uxp.hyd.int.pc.app_header.footer.privacy_policy.link.click'
  },
  doNotSell: {
    golf: 'Shared:Footer:Privacy:DoNotSell',
    eid: 'uxp.hyd.int.pc.app_header.footer.do_not_sell.link.click'
  }
};
/**
 * Render Application Footer
 *
 * @class Footer
 *
 * @returns {React.ReactElement} Application Footer
 * @api public
 */
class ApplicationFooter extends _react.Component {
  constructor() {
    super(...arguments);
    this.htmlClassName = 'footer-html';
    this.setHeight = this.setHeight.bind(this);
  }

  /**
   * Calculate height and add as margin to the bottom.
   *
   * @returns {Footer} fluent interface.
   * @api private
   */
  setHeight() {
    return this;
  }

  /**
   * Add className to the html element to display the footer.
   *
   * @returns {Footer} fluent interface.
   * @api private
   */
  addClassName() {
    const html = this.body.parentNode;
    html.className = html.className.split(' ').concat(this.htmlClassName).filter(Boolean).join(' ');
    return this;
  }

  /**
   * Renders the footer links
   *
   * @param {Object}   props Full set of props for this component
   * @param {String}   url url for link
   * @param {Object}   name Set of golf string and eid
   * @returns {React.Component} a for privacy link
   */
  buildPrivacyLink(props, url, name) {
    const {
      privateLabelId,
      privateLabelType
    } = props;
    // API Resellers and plid=3153 is used when "we do not know" the plid. In both cases we remove the privacy policy link.
    if (privateLabelId === 3153 || privateLabelType === 3) {
      return;
    }
    return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
      className: "privacy-link"
    }, url, {
      "data-eid": privacyLinks[name].eid
    }), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: privacyLinks[name].golf
    }));
  }

  /**
   * Add margin to the bottom of the body on mount and resizes to create space
   * for the absolutely positioned footer.
   *
   * @api private
   */
  componentDidMount() {
    this.body = document.body;
    typeof document !== 'undefined' && document.addEventListener('resize', this.setHeight);
    this.addClassName().setHeight();
  }

  /**
   * Remove the resize eventlistener when the component is unmounted.
   *
   * @api private
   */
  componentWillUnmount() {
    const html = this.body.parentNode;
    html.className = html.className.replace(this.htmlClassName, '');
    if (typeof document !== 'undefined') {
      document.removeEventListener('resize', this.setHeight);
    }
  }
  render() {
    const props = this.props;

    // This is a temporary fix for UXP-8452, specific for 123Reg.
    // This hardcoded solution should be improved as per https://godaddy-corp.atlassian.net/browse/UXP-8451
    if (PLIDS_FOR_123_REG.includes(props.privateLabelId)) {
      return /*#__PURE__*/_react.default.createElement("footer", {
        id: "appheader-footer",
        className: "manifest footer",
        ref: c => {
          this.element = c;
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "app-footer-container footer-container123"
      }, /*#__PURE__*/_react.default.createElement("p", null, "Copyright \xA9 ", new Date().getFullYear(), " 123 Reg Ltd. All prices exclude VAT, which is charged based on the location where a service is deemed to be used by a customer."), /*#__PURE__*/_react.default.createElement("div", {
        className: "policies-container123"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "https://www.123-reg.co.uk/terms/privacy/",
        target: "_blank",
        rel: "noreferrer"
      }, "Privacy policy"), /*#__PURE__*/_react.default.createElement("a", {
        href: "https://www.123-reg.co.uk/terms/cookie-law-terms/",
        target: "_blank",
        rel: "noreferrer"
      }, "Manage cookies"))));
    }
    const features = props.features || {};
    let copyright = 'PC:AppHeader:Footer:Copyright';
    if (props.privateLabelId !== 1) {
      copyright += 'PL';
    }
    return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("footer", {
      id: "appheader-footer",
      className: "manifest footer",
      ref: c => {
        this.element = c;
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "app-footer-container"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: copyright,
      values: {
        year: props.year
      }
    }), ' ' /* intentional whitespace, JSX parser limitation */, this.buildPrivacyLink(props, props.urls.privacy, 'policy'), features.doNotSellLink && props.urls.cookies && /*#__PURE__*/_react.default.createElement("div", {
      className: "do-not-sell"
    }, this.buildPrivacyLink(props, props.urls.cookies, 'doNotSell'))))));
  }
}

/**
 * Default properties for the Footer. Year is only provided as fallback value
 * and should always be replaced with server time.
 *
 * @type {Object}
 * @api public
 */
ApplicationFooter.defaultProps = {
  /** default output for privacy link */
  urls: {
    privacy: {
      href: 'https://www.godaddy.com/agreements/showdoc.aspx?pageid=PRIVACY'
    }
  },
  /** current year for copyright */
  year: new Date().getFullYear(),
  /** default to GD plid */
  privateLabelId: 1
};

/**
 * Require properties.
 *
 * @type {Object}
 * @api public
 */
ApplicationFooter.propTypes = {
  /** flags that indicate special link consideration */
  features: _propTypes.default.object,
  /** react-intl i18n messages */
  messages: _propTypes.default.object.isRequired,
  /** current market */
  market: _propTypes.default.string.isRequired,
  /** current plid */
  privateLabelId: _propTypes.default.number,
  /** output from @ux/hrefs for link generation */
  urls: _propTypes.default.object,
  /** current year for copyright */
  year: _propTypes.default.number
};
var _default = ApplicationFooter;
exports.default = _default;